import Chart from 'chart.js/auto';

const renderOtifOdrChartToBase64 = html => {
  return new Promise((resolve, reject) => {
    const container = document.createElement('div');
    container.style.cssText =
      'position:fixed;top:-9999px;left:-9999px;width:1800px;height:900px;background:#ffffff;';
    document.body.appendChild(container);

    container.innerHTML = html;

    const chartWrap = container.querySelector('.otif-chart-wrap');
    if (chartWrap) {
      chartWrap.style.width = '1780px';
      chartWrap.style.height = '650px';
    }

    window.Chart = Chart;

    container.querySelectorAll('script:not([src])').forEach(oldScript => {
      const newScript = document.createElement('script');
      newScript.textContent = oldScript.textContent;
      document.body.appendChild(newScript);
      document.body.removeChild(newScript);
    });

    setTimeout(() => {
      try {
        const chartCanvas = container.querySelector('canvas');
        if (!chartCanvas) throw new Error('Canvas not found in chart HTML');

        const stats = extractSummaryStats(container);
        const chartW = chartCanvas.width || 1780;
        const chartH = chartCanvas.height || 650;
        const kpiH = 150;

        const finalCanvas = document.createElement('canvas');
        finalCanvas.width = chartW;
        finalCanvas.height = kpiH + chartH;
        const ctx = finalCanvas.getContext('2d');

        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

        const cardW = chartW / 3;
        const labels = ['Avg OTIF', 'Total ODR Raised', 'Total Jobs'];
        const values = [stats.avgOtif, stats.totalOdr, stats.totalJobs];
        const colors = ['#1ab394', '#ed5565', '#1c84c6'];
        labels.forEach((label, i) => {
          const x = i * cardW;
          ctx.strokeStyle = '#e7eaec';
          ctx.lineWidth = 1;
          ctx.strokeRect(x + 4, 4, cardW - 8, kpiH - 8);

          ctx.fillStyle = '#555555';
          ctx.font = 'bold 12px Arial';
          ctx.textAlign = 'left';
          ctx.fillText(label, x + 12, 26);

          ctx.fillStyle = '#aaaaaa';
          ctx.font = '10px Arial';
          ctx.textAlign = 'right';
          ctx.fillText('Last 28 days', (i + 1) * cardW - 12, 26);

          ctx.fillStyle = colors[i];
          ctx.font = 'bold 28px Arial';
          ctx.textAlign = 'left';
          ctx.fillText(values[i], x + 12, 70);
        });
        ctx.textAlign = 'left';

        ctx.drawImage(chartCanvas, 0, kpiH);

        const base64 = finalCanvas
          .toDataURL('image/png')
          .replace('data:image/png;base64,', '');

        document.body.removeChild(container);
        delete window.Chart;
        resolve(base64);
      } catch (err) {
        document.body.removeChild(container);
        delete window.Chart;
        reject(err);
      }
    }, 500);
  });
};

const extractSummaryStats = domEl => {
  const nums = domEl.querySelectorAll('.otif-big-num');
  return {
    avgOtif: nums[0]?.textContent.trim() || 'N/A',
    totalOdr: nums[1]?.textContent.trim() || 'N/A',
    totalJobs: nums[2]?.textContent.trim() || 'N/A'
  };
};

const renderChartsToBase64Array = html => {
  return new Promise((resolve, reject) => {
    const container = document.createElement('div');
    container.style.cssText =
      'position:fixed;top:-9999px;left:-9999px;width:1800px;height:900px;background:#ffffff;';
    document.body.appendChild(container);

    container.innerHTML = html;

    container.querySelectorAll('.otif-chart-wrap').forEach(el => {
      el.style.width = '1780px';
      el.style.height = '650px';
    });

    window.Chart = Chart;

    container.querySelectorAll('script:not([src])').forEach(oldScript => {
      const newScript = document.createElement('script');
      newScript.textContent = oldScript.textContent;
      document.body.appendChild(newScript);
      document.body.removeChild(newScript);
    });

    setTimeout(() => {
      try {
        const canvases = container.querySelectorAll('canvas');
        if (!canvases.length) throw new Error('No canvas found in chart HTML');

        const results = [];

        const firstChartInstance = window.Chart?.getChart
          ? window.Chart.getChart(canvases[0])
          : null;
        const daysCount = firstChartInstance?.data?.labels?.length ?? null;
        const dayLabel = daysCount ? `Last ${daysCount} days` : 'Last 28 days';

        canvases.forEach((chartCanvas, i) => {
          const chartW = chartCanvas.width || 1780;
          const chartH = chartCanvas.height || 650;

          if (i === 0) {
            const stats = extractSummaryStats(container);
            const kpiH = 150;
            const finalCanvas = document.createElement('canvas');
            finalCanvas.width = chartW;
            finalCanvas.height = kpiH + chartH;
            const ctx = finalCanvas.getContext('2d');

            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

            const cardW = chartW / 3;
            const kpiLabels = ['Avg OTIF', 'Total ODR Raised', 'Total Jobs'];
            const values = [stats.avgOtif, stats.totalOdr, stats.totalJobs];
            const colors = ['#1ab394', '#ed5565', '#1c84c6'];
            kpiLabels.forEach((label, j) => {
              const x = j * cardW;
              ctx.strokeStyle = '#e7eaec';
              ctx.lineWidth = 1;
              ctx.strokeRect(x + 4, 4, cardW - 8, kpiH - 8);
              ctx.fillStyle = '#555555';
              ctx.font = 'bold 12px Arial';
              ctx.textAlign = 'left';
              ctx.fillText(label, x + 12, 26);
              ctx.fillStyle = '#aaaaaa';
              ctx.font = '10px Arial';
              ctx.textAlign = 'right';
              ctx.fillText(dayLabel, (j + 1) * cardW - 12, 26);
              ctx.fillStyle = colors[j];
              ctx.font = 'bold 28px Arial';
              ctx.textAlign = 'left';
              ctx.fillText(values[j], x + 12, 70);
            });
            ctx.textAlign = 'left';
            ctx.drawImage(chartCanvas, 0, kpiH);
            results.push(
              finalCanvas
                .toDataURL('image/png')
                .replace('data:image/png;base64,', '')
            );
          } else {
            const finalCanvas = document.createElement('canvas');
            finalCanvas.width = chartW;
            finalCanvas.height = chartH;
            const ctx = finalCanvas.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, chartW, chartH);
            ctx.drawImage(chartCanvas, 0, 0);
            results.push(
              finalCanvas
                .toDataURL('image/png')
                .replace('data:image/png;base64,', '')
            );
          }
        });

        document.body.removeChild(container);
        delete window.Chart;
        resolve({ bases: results, daysCount: daysCount ?? 28 });
      } catch (err) {
        document.body.removeChild(container);
        delete window.Chart;
        reject(err);
      }
    }, 500);
  });
};

export { renderOtifOdrChartToBase64, extractSummaryStats, renderChartsToBase64Array };
